import React from "react";
import { Box, Typography, Button } from "@mui/material";
import NoVm from '../../assets/novmfound.png'
import BgAll from '../../assets/bgAll.png'
// Base URL for images
const BASE_IMAGE_URL = "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod";


const NoVmFound = ({ onFetchLocation }) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        width:"100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
       
        borderRadius: 2,
        overflow: "hidden",
        position: "relative",
        //backgroundImage: `url(${BgAll})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          //background: "rgba(0,0,0,0.2)", // optional overlay to enhance text visibility
          zIndex: -1,
          animation: "fadeOverlay 5s ease-in-out infinite alternate",
        },
      }}
    >
      <img
        src={NoVm}
        alt="No VMs"
        style={{ width: 150, height: 150, marginBottom: 24 }}
      />
      <Typography variant="h6" gutterBottom>
        No vending machines found
      </Typography>
      <Typography variant="body2" color="textSecondary" mb={2}>
        Please allow location access to find nearby machines.
      </Typography>
     {/*  <Button
        variant="contained"
        color="primary"
        onClick={onFetchLocation}
        sx={{ textTransform: "none" }}
      >
        Click here to get your location
      </Button> */}
    </Box>
  );
};

export default NoVmFound;
